module.exports = __webpack_public_path__ + "img/orderbook@2x.617eb190.png";